import L from 'leaflet';
import markerLightBlue from './assets/marker-lightBlue.svg';
import markerRed from './assets/marker-red.svg';
import markerBlue from './assets/marker-blue.svg';
import pointLightBlue from './assets/point-blue.svg';
import type { MapMakerType } from './types';

export const markerLightBlueIcon = L.icon({
  iconUrl: markerLightBlue,
  iconAnchor: [12.5, 32.5],
  popupAnchor: [0, -37.5],
  iconSize: [25, 32.5],
});

export const markerRedIcon = L.icon({
  iconUrl: markerRed,
  iconAnchor: [12.5, 32.5],
  popupAnchor: [0, -37.5],
  iconSize: [25, 32.5],
});

export const markerBlueIcon = L.icon({
  iconUrl: markerBlue,
  iconAnchor: [12.5, 32.5],
  popupAnchor: [0, -37.5],
  iconSize: [25, 32.5],
});

export const pointLightBlueIcon = L.icon({
  iconUrl: pointLightBlue,
  iconAnchor: [10, 32.5],
  popupAnchor: [0, -40],
  iconSize: [20, 20],
});

export const ICON_FOR_MARKER_TYPE: Record<MapMakerType, any> = {
  'marker-lightBlue': markerLightBlueIcon,
  'marker-red': markerRedIcon,
  'marker-blue': markerBlueIcon,
  'point-grey': pointLightBlueIcon,
};

export const ICON_IMG_FOR_MARKER_TYPE: Record<MapMakerType, any> = {
  'marker-lightBlue': markerLightBlue,
  'marker-red': markerRed,
  'marker-blue': markerBlue,
  'point-grey': pointLightBlueIcon,
};
